import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useUserHasPermission = (role) => {
  const history = useHistory();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && !user?.roles?.includes(role)) {
      history.push('/airport-list');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
